import "./index.less";
import { useState,useEffect } from "react";
import useGetUserInfo from '../../hooks/useGetUserInfo'
import apiService from '../../services/tokenAjax'
import { Button, message } from 'antd'
import { useDispatch } from 'react-redux'
import { ethers } from 'ethers';
import { loginReducer } from '../../store/userReducer'
import WalletButton from "../../components/WalletButton"
import copyIcon from "../../img/copyIcon.png";
import tokenLogo from "../../img/tokenLogo.png";
import { useTranslation } from "react-i18next";

declare let window: any
const MyToken = () => {
  const { t, i18n }: { t: any,i18n:any } = useTranslation();
  const [current, setCurrent] = useState(0);
  const { username, nickname } = useGetUserInfo()
  const [list,setList] = useState([])
  // console.log(`username:${username},nickname:${nickname}`)
  const dispatch = useDispatch();
  const isEmpty = (value:any) => {
      // 处理 null 或 undefined
      if (value === null || value === undefined) {
        return true;
      }
      // 处理字符串（包括空白字符）
      if (typeof value === 'string') {
        return value.trim() === '';
      }
      // 其他类型默认视为非空（如数字、对象等）
      return false;
  };
  const copyAddress = async (address) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(address);
    } else {
      const textarea = document.createElement('textarea');
      textarea.value = address
      textarea.style.position = 'absolute';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    message.success(`Replicating Success`);
  };
  async function getList(username: string) {
    try {
      const response = await apiService.fetchList(`token/tokenUid?addressUid=${username}&appKey=3269830f92740058b8b32a1f863b37581a5cc1fe421d68c7fcc5a36358d89a63`);
      setList(response.data.data);
      console.log(`response:${JSON.stringify(response)}`)
      return response.data.data;
    } catch (error) {
        message.error('数据加载失败');
        console.error('Error fetching data:', error);
    } 
  }
  useEffect(() => {
      if (!isEmpty(username)) {
        getList(username);
      }
    }, [username])
  const onClickConnect = () => {
          //client side code
          if (!window.ethereum) {
          console.log('please install MetaMask')
          return
          }
          const provider = new ethers.providers.Web3Provider(window.ethereum)
          //we can do it using ethers.js
          provider
          .send('eth_requestAccounts', [])
          .then(accounts => {
              if (accounts.length > 0) {
                  // dispatch(addAddress(currentAccount))
                  // console.log(`currentAccount:${currentAccount}`)
                  dispatch(loginReducer({ 'username':accounts[0], 'nickname':'OK' }))
              }
          })
          .catch(e => console.log(e))
      }
  return (
    <div className="deployed-layout">
      {/* <div className="deployed-layout-header">
        <div className="deployed-layout-header-title">Deployed tokens</div>
        <div className="deployed-layout-header-desc">
          View your deployed tokens
        </div>
      </div> */}
      {!isEmpty(username) ?
        <div className="deployed-layout-tokens">
          {list.map((item) => (
            <div className="token-info-card">
              <div className="token-info-card-header">
                <img className="card-header-left" src={item.logoUrl?item.logoUrl:tokenLogo} style={{ width: '56px', height: '56px', borderRadius: '50%' }} />
                <div className="card-header-middle">
                  <div className="card-header-middle-title">{item.name} ({item.symbol})</div>
                  <div className="card-header-middle-address">
                    {item.contractAddress.substring(0, 6)}...{item.contractAddress.slice(-4)}
                    <img src={copyIcon} alt="" onClick={()=>copyAddress(item.contractAddress)} />
                  </div>
                </div>
                {/* <div >
                  <Button rootClassName="manage-token-btn" ghost style={{ display:'flex',justifyContent:'center',flexDirection:'row'}}>
                    管理<EditOutlined/>
                  </Button>
                </div> */}
                
              </div>
              <div className="token-info-card-content">
                <div className="token-card-item">
                  <span className="token-card-item-left"> {t('It45')} </span>
                  <span className="token-card-item-right">{item.tokenAmount} {item.symbol}</span>
                </div>
                <div className="token-card-item">
                  <span className="token-card-item-left">{t('It46')} </span>
                  <span className="token-card-item-right">{ item.createTime!=""?item.createTime.substring(0, 10):" " }</span>
                </div>
              </div>
            </div>
            ))}
        </div>
      :
      <div className="deployed-layout-wrapper">
        {(current === 0 || current == 2) && (
          <div className="deployed-layout-content">
            <img src="/icon/connect.svg" alt="" />
            {current === 0 ? (
              <p className="deployed-layout-content-desc">
                {t('It47')}
              </p>
            ) : (
              <p className="deployed-token-none">No deployment yet~</p>
            )}
            {current === 0 && (
              // <Button size="large" rootClassName="connect-wallet-btn" onClick={onClickConnect}>
              //   Connect wallet
              // </Button>
              <WalletButton></WalletButton>
            )}
          </div>
        )}
      </div>
      }
      {/* 未连接钱包0-部署tokens1-未部署token2 */}
      
    </div>
  );
};
export default MyToken;
